import { Component } from '@angular/core';
import { FormBuilder,Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';
import { AbacService } from '../../../../core/services/abac.service';
import { AuthenticationService } from '../../services/authentication.service';
import { SetThemeService } from '../../../../shared/services/set-theme.service';
import { statusCodes } from '../../../../shared/constants/statusCodes';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent{
 
    errorMessage = '';
    usernameErrorMessage = '';
    isloading = false;
    submitted = false;
    LOGO='https://swaasitsolutions.azureedge.net/swaas/images/swaas_logo.webp';
    userDetails: any;
    hide= true;   
  
    constructor(public readonly router: Router, public readonly fb: FormBuilder,private readonly setTheme:SetThemeService, private readonly authService: AuthService,private readonly abacService : AbacService,
      private readonly authenticationService : AuthenticationService
    ){}
    
    LoginForm = this.fb.group({
      user_name: [null, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(6)]]
    });
    Login() : void {
      this.errorMessage = ''
      if(this.LoginForm.valid){
        const username = this.LoginForm.controls['user_name'].value;
        const password = this.LoginForm.controls['password'].value;
        const obj = { username : username, password : password }
      this.authenticationService.login(obj).subscribe({
          next: (response) => {
            if (response.code === statusCodes.SUCCESS) {
              this.authService.saveUserDetails(response.data)
              this.abacService.setAccessControl();
              this.authService.login(true);
              this.LoginForm.reset();
              this.router.navigateByUrl('/home');
              this.setTheme.applyTheme(response.data[0].userId);
            }
          },
          error: () => { 
            this.errorMessage = 'Unable to connect DB' 
          }
        })
      }
      else{
        if (this.LoginForm.controls['user_name'].value === null) {
          this.LoginForm.controls['user_name'].markAsTouched()
        }
        if (this.LoginForm.controls['password'].value === null) {
          this.LoginForm.controls['password'].markAsTouched()
        }
      }
    }
  
   
  
  }
  
  